var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * NumberFiveFilled component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconNumberFiveFilled extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12 23C14.9174 23 17.7153 21.8411 19.7782 19.7782C21.8411 17.7153 23 14.9174 23 12C23 9.08262 21.8411 6.28473 19.7782 4.22183C17.7153 2.15893 14.9174 1 12 1C9.08262 1 6.28473 2.15893 4.22183 4.22183C2.15893 6.28473 1 9.08262 1 12C1 14.9174 2.15893 17.7153 4.22183 19.7782C6.28473 21.8411 9.08262 23 12 23ZM14.75 8.26786H10.4757L10.1159 10.4129C10.5794 10.2934 11.0587 10.2321 11.5396 10.2321H12.7857C14.6306 10.2321 16.125 11.7266 16.125 13.5714V14.3571C16.125 15.2428 15.7732 16.0921 15.1469 16.7184C14.5207 17.3446 13.6713 17.6964 12.7857 17.6964H11.2143C10.5236 17.6963 9.8499 17.4822 9.28594 17.0834C8.72198 16.6846 8.29548 16.1209 8.06514 15.4697C7.97845 15.224 7.99292 14.954 8.10534 14.7189C8.21777 14.4839 8.41896 14.3032 8.66464 14.2165C8.91033 14.1298 9.18039 14.1443 9.41541 14.2567C9.65043 14.3691 9.83117 14.5703 9.91786 14.816C10.1064 15.3503 10.6171 15.7321 11.2143 15.7321H12.7857C13.1504 15.7321 13.5001 15.5873 13.758 15.3294C14.0158 15.0716 14.1607 14.7218 14.1607 14.3571V13.5714C14.1607 13.2068 14.0158 12.857 13.758 12.5992C13.5001 12.3413 13.1504 12.1964 12.7857 12.1964H11.5411C10.9613 12.1964 10.3909 12.3316 9.87229 12.5893L9.29714 12.8784C9.13502 12.9599 8.95349 12.9949 8.7727 12.9795C8.59191 12.964 8.41893 12.8988 8.27293 12.7911C8.12694 12.6834 8.01365 12.5373 7.94563 12.3691C7.8776 12.2008 7.85751 12.0171 7.88757 11.8381L8.67329 7.12386C8.71161 6.89447 8.8301 6.68613 9.00765 6.53591C9.1852 6.3857 9.41029 6.30337 9.64286 6.30357H14.75C15.0105 6.30357 15.2603 6.40705 15.4445 6.59123C15.6287 6.77542 15.7321 7.02523 15.7321 7.28571C15.7321 7.54619 15.6287 7.79601 15.4445 7.98019C15.2603 8.16438 15.0105 8.26786 14.75 8.26786Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconNumberFiveFilled.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconNumberFiveFilled.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconNumberFiveFilled.prototype, "size", void 0);
if (customElements.get('cat-icon-number-five-filled') === undefined) {
    customElements.define('cat-icon-number-five-filled', BlocksIconNumberFiveFilled);
}
